import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    username: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });

    // Fehler für dieses Feld löschen
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = 'Vorname ist erforderlich';
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = 'Nachname ist erforderlich';
    }

    if (!formData.username.trim()) {
      newErrors.username = 'Benutzername ist erforderlich';
    } else if (formData.username.length < 3) {
      newErrors.username = 'Benutzername muss mindestens 3 Zeichen lang sein';
    } else if (!/^[a-zA-Z0-9_-]+$/.test(formData.username)) {
      newErrors.username = 'Benutzername darf nur Buchstaben, Zahlen, _ und - enthalten';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'E-Mail ist erforderlich';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'E-Mail-Format ist ungültig';
    }

    if (!formData.password) {
      newErrors.password = 'Passwort ist erforderlich';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Passwort muss mindestens 6 Zeichen lang sein';
    }

    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Passwörter stimmen nicht überein';
    }


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    const result = await register(formData);

    if (result.success) {
      navigate('/login');
    }

    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="container">
        <div className="auth-form">
          <h2>Registrieren</h2>

          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">Vorname *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  placeholder="Ihr Vorname"
                />
                {errors.firstName && <div className="error">{errors.firstName}</div>}
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Nachname *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  placeholder="Ihr Nachname"
                />
                {errors.lastName && <div className="error">{errors.lastName}</div>}
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="username">Benutzername *</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                placeholder="Ihr Benutzername (min. 3 Zeichen)"
              />
              {errors.username && <div className="error">{errors.username}</div>}
            </div>

            <div className="form-group">
              <label htmlFor="email">E-Mail-Adresse *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="ihre.email@beispiel.de"
              />
              <small style={{color: '#dc143c', fontSize: '0.85rem', marginTop: '0.25rem', display: 'block', fontWeight: '500'}}>
                ⚠️ Wichtig: Verwenden Sie die gleiche E-Mail wie in der Mainaqila App!
              </small>
              {errors.email && <div className="error">{errors.email}</div>}
            </div>

            <div className="form-group">
              <label htmlFor="password">Passwort *</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="Mindestens 6 Zeichen"
              />
              {errors.password && <div className="error">{errors.password}</div>}
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Passwort bestätigen *</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                placeholder="Passwort wiederholen"
              />
              {errors.confirmPassword && <div className="error">{errors.confirmPassword}</div>}
            </div>


            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Registrieren...' : 'Registrieren'}
            </button>
          </form>

          <div className="auth-links">
            <p>
              Bereits ein Account?{' '}
              <Link to="/login">Jetzt anmelden</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
